export const tangoLogo = "/images/tango-logo.png";
export const usericon = "/images/usericon.png";
export const videoPlaceholderImage = "/images/Tango-2023-Logos-Final-Tagline-A-Blue-Green-Trademark.png";
export const tangoLogoLoader = "/images/tangoSmallT.png";
export const dinaPageImage = "/images/DinaPage.png";
